// extracted by mini-css-extract-plugin
module.exports = {"reversed":"EmailLink_reversed__3MVC2"};